import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { MAINTENANCE_MODE } from "@/config";
import { Maintenance } from "@/pages/Maintenance";
import { SiteLayout } from "@/components/site/SiteLayout";
import { Home } from "@/pages/Home";
import { Orientation } from "@/pages/Orientation";
import { Alternance } from "@/pages/Alternance";
import { Offers } from "@/pages/Offers";
import { Testimonials } from "@/pages/Testimonials";
import { FAQ } from "@/pages/FAQ";
import { About } from "@/pages/About";
import { Booking } from "@/pages/Booking";
import { Contact } from "@/pages/Contact";
import { CheckoutSuccess } from "@/pages/CheckoutSuccess";
import { Legal } from "@/pages/Legal";
import { AdminLogin } from "@/pages/AdminLogin";
import { AdminDashboard } from "@/pages/AdminDashboard";

const site = (el) => <SiteLayout>{el}</SiteLayout>;

function App() {
  if (MAINTENANCE_MODE) {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Maintenance />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={site(<Home />)} />
          <Route path="/orientation" element={site(<Orientation />)} />
          <Route path="/alternance" element={site(<Alternance />)} />
          <Route path="/offres" element={site(<Offers />)} />
          <Route path="/temoignages" element={site(<Testimonials />)} />
          <Route path="/faq" element={site(<FAQ />)} />
          <Route path="/a-propos" element={site(<About />)} />
          <Route path="/reservation" element={site(<Booking />)} />
          <Route path="/contact" element={site(<Contact />)} />
          <Route path="/paiement/succes" element={site(<CheckoutSuccess />)} />
          <Route path="/mentions-legales" element={site(<Legal />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
